import { TLCLogger } from "../../../js/lib/logger";
import { LandingPageUtil } from "./LandingPageUtil";

export class SliderPage2 {
  constructor(id, options, isVisible, isFirst) {
    this.slideSpeed = 900;
    this.GRID_MARGIN = 31;

    this.pageId = id;

    this.photoWidth = options.jacketWidth;
    this.photoHeight = options.jacketHeight;
    this.marginLeft = options.marginLeft;
    this.pageWidth = options.pageWidth;
    this.pageHeight = options.pageHeight;
    this.pageSize = options.pageLength;

    this.isVisible = isVisible || false;
    this.loaded = false;
    this.isFirst = isFirst || false;
    this.listItems = [];

    this.init();
  }
  destroy() {
    const page = $("#" + this.pageId);
    page.find("img").off("load").off("error");
    page.stop(true, true).remove();
  }
  getPageId() {
    return this.pageId;
  }
  getPage() {
    return this.listItems;
  }
  getVisible() {
    return this.isVisible;
  }
  load(resources) {
    this.listItems = resources;
    var _this = this;
    $.each(this.listItems, function (i, listItem) {
      _this.loadJacket(i, listItem);
    });
    this.removeJackets();
    this.loaded = true;
  }
  isLoaded() {
    return this.loaded;
  }
  getPageCount() {
    return this.listItems.length;
  }
  removeJackets() {
    if (this.listItems.length < this.pageSize) {
      for (var n = this.listItems.length; n < this.pageSize; n++) {
        $("#" + this.pageId + "_" + n).remove();
      }
    }
  }
  getImageDimensions(realWidth, realHeight) {
    var maxWidth = this.photoWidth,
      maxHeight = this.photoHeight,
      minMatte = 10;
    return LandingPageUtil.getImageDimensions(
      realWidth,
      realHeight,
      maxWidth,
      maxHeight,
      minMatte
    );
  }
  getImageCSS(dimensions) {
    return {
      height: dimensions.height + "px",
      "margin-top": dimensions.marginTop + "px",
      "margin-bottom": dimensions.marginBottom + "px",
      width: dimensions.width + "px",
      "margin-left": dimensions.marginLeft + "px",
      "margin-right": dimensions.marginRight + "px",
    };
  }
  getJacketCSS(photoWidth, photoHeight, marginLeft) {
    return {
      height: photoHeight + "px",
      width: photoWidth + "px",
      "margin-left": marginLeft + "px",
    };
  }
  updateLeftPosition(pageWidth) {
    if (!this.isVisible) {
      $("#" + this.pageId).css({
        left: pageWidth + "px",
      });
    }
  }
  updateTopPosition(pageHeight) {
    if (!this.isVisible) {
      $("#" + this.pageId).css({
        top: pageHeight + "px",
      });
    }
  }
  resizeJackets(resizeDimensions) {
    var pageHeight = resizeDimensions.pageHeight,
      pageWidth = resizeDimensions.pageWidth,
      jacketWidth = resizeDimensions.jacketWidth,
      jacketHeight = resizeDimensions.jacketHeight,
      marginLeft = resizeDimensions.marginLeft;

    this.photoWidth = jacketWidth;
    this.photoHeight = jacketHeight;
    this.marginLeft = resizeDimensions.marginLeft;
    this.pageHeight = pageHeight;
    this.updateLeftPosition(pageWidth);
    this.updateTopPosition(pageHeight);
    var _this = this;

    var jackets = $("#" + this.pageId + " .jacket");
    $("#" + this.pageId).css({
      height: pageHeight + "px",
      width: pageWidth + "px",
    });
    $.each(jackets, function (i, jacket) {
      var $jacket = $(jacket),
        jacketImg = $jacket.find("img");
      var dimensions = _this.getImageDimensions(
        jacketImg.attr("data-real-width"),
        jacketImg.attr("data-real-height"),
        jacketWidth,
        jacketHeight
      );
      $jacket.css(_this.getJacketCSS(jacketWidth, jacketHeight, marginLeft));
      jacketImg
        .height(dimensions.height)
        .width(dimensions.width)
        .css(_this.getImageCSS(dimensions));
    });
  }
  remove() {
    $("#" + this.pageId).remove();
  }
  loadJacket(imageIndex, resource) {
    var img = $("#" + this.pageId + " img")[imageIndex],
      jacket = $("#" + this.pageId + " .jacket").eq(imageIndex),
      _this = this;

    $(img)
      .css({
        display: "none",
      })
      .on("load", function () {
        var dimensions = _this.getImageDimensions(
          resource.realWidth,
          resource.realHeight
        );
        //TODO only fade in if visible if(_this.isVisible)
        //TODO resource id should be on the jacket
        $(jacket).attr("data-resource-id", resource.id).spin(false);
        const url = new URL(window.location);
        url.hash = `#/resource/${resource.id}`;
        $(jacket).attr("href", url.toString());
        $(img)
          .height(dimensions.height)
          .width(dimensions.width)
          .attr("data-real-height", resource.realHeight)
          .attr("data-real-width", resource.realWidth)
          .attr("alt", resource.shortTitle)
          .css(_this.getImageCSS(dimensions))
          .fadeIn("slow", function () {
            $(img).css({
              display: "block",
            });
          });
      })
      .on("error", function () {
        TLCLogger.log("image failed to load");
      })
      .attr("src", resource.jacketURL);
  }
  checkLeftEdge(endingPosition) {
    if (
      this.isFirst === true &&
      (endingPosition === 0 || endingPosition === undefined)
    ) {
      return -1;
    } else if (endingPosition === undefined) {
      return 0;
    }
    return endingPosition;
  }
  animateDown(callback) {
    this.animateVertically(true, callback);
  }
  animateUp(callback) {
    this.animateVertically(false, callback);
  }
  animateVertically(isDown, callback) {
    var page = $("#" + this.pageId),
      pageHeight = page.height(),
      endingPosition = 0;
    if (this.isVisible === true) {
      //we're already at 0, 0
      endingPosition = pageHeight + this.GRID_MARGIN;
      if (isDown === false) {
        endingPosition = "-" + endingPosition;
      }
      this.isVisible = false;
    } else {
      var startingPosition = this.GRID_MARGIN + pageHeight;
      if (isDown === true) {
        startingPosition = "-" + startingPosition;
      }
      $("#" + this.pageId)
        .css({
          top: startingPosition + "px",
          left: this.checkLeftEdge(0) + "px",
          "z-index": 1,
          display: "block",
        })
        .find("img")
        .css({
          "z-index": 2,
          display: "block",
        });
      this.isVisible = true;
    }
    page.animate(
      {
        top: endingPosition + "px",
      },
      this.slideSpeed,
      function () {
        if (callback) {
          callback();
        }
      }
    );
  }
  animateIn(startingPosition, callback, endingPosition) {
    var page = $("#" + this.pageId),
      leftPosition = this.checkLeftEdge(endingPosition);
    if (this.isVisible === false) {
      page
        .css({
          display: "block",
          left: startingPosition + "px",
          top: 0,
          "z-index": 1,
        })
        .find("img")
        .css({
          "z-index": 2,
          display: "block",
        });
    }
    this.isVisible = true;
    page.animate(
      {
        left: leftPosition + "px",
      },
      this.slideSpeed,
      function () {
        //TODO if page doneLoading else, setTimeout and check
        if (callback) {
          callback();
        }
      }
    );
  }
  animateOut(direction, callback, remainVisible) {
    var page = $("#" + this.pageId),
      _this = this;
    page.animate(
      {
        left: direction + "px",
      },
      this.slideSpeed,
      function () {
        if (remainVisible !== true) {
          _this.isVisible = false;
          page.css({
            "z-index": 0,
            display: "none",
          });
        }
        if (callback) {
          callback();
        }
      }
    );
  }
  init(overwrite /* optional*/) {
    var pageContent = [],
      i = 0,
      leftPos = null,
      pageItems = this.getPage(),
      pageId = this.pageId,
      _this = this;

    if (this.isVisible) {
      leftPos = this.checkLeftEdge(0);
    }
    pageContent[i++] = '<div class="page';
    if (this.isFirst) {
      pageContent[i++] = " firstPage";
    }
    pageContent[i++] = '" id="';
    pageContent[i++] = pageId;
    pageContent[i++] = '" style="height:' + this.pageHeight + "px;width:";
    pageContent[i++] = this.pageWidth;
    pageContent[i++] = "px;left:";
    pageContent[i++] =
      leftPos === null ? this.pageWidth + "px" : leftPos + "px";
    pageContent[i++] = ';">';
    pageContent[i++] = '<div style="position:relative;">';
    for (var n = 0; n < this.pageSize; n++) {
      var imageId = this.pageId + "_" + n;
      pageContent[i++] =
        '<a id="' +
        imageId +
        '" href="'+window.location+'" class="jacket" style="width:';
      pageContent[i++] = Math.floor(this.photoWidth);
      pageContent[i++] = "px;height:";
      pageContent[i++] = Math.floor(this.photoHeight);
      pageContent[i++] = "px;margin-left:";
      pageContent[i++] = Math.floor(this.marginLeft);
      pageContent[i++] = 'px;" aria-label="Open image ' + imageId + '" >';
      pageContent[i++] = '<img style="display:none" ';
      pageContent[i++] =
        'alt="Carousel placeholder ' + this.pageId + " image " + n + '" />';
      pageContent[i++] = "</a>";
    }
    pageContent[i++] = "</div>";
    pageContent[i++] = "</div>";
    $(".jacketContainer").append(pageContent.join(""));
    var jackets = $("#" + this.pageId + " .jacket");
    jackets.spin();
  }
}
